<template>
  <div>
    <div v-if="switchActive==0||switchActive==1">
      <!-- header -->
      <div :class="$route.path=='/'?'header1':'header2'">
        <indexHeader ref="indexHeader" fromPage="index" :switchActive="switchActive" @hangleActive="hangleActive"
          :class="isFixed == true ? 'isfixed' : ''"></indexHeader>
      </div>
      <!-- banner -->
      <div class="bannerBg" v-show="$route.path=='/'|| $route.path=='/courseIndex'||$route.path=='/schedule'">
        <div class="index_index bannerBox">
          <!-- 轮播图 -->
          <div class="bannerImg">
            <el-carousel indicator-position="none" :interval="10000" height="418px">
              <el-carousel-item v-for="item in bannerList" :key="item.id">
                <img :src="item.bannerUrl" />
              </el-carousel-item>
            </el-carousel>
          </div>


          <!--<div class="banner_img">
            <div class="banner_warp" v-if="token">
              <div class="banner_title">线上信用培训</div>
              <div class="banner_text">信用好则企业兴，信用差则企业发展困难重重。<br />汇信科技，全心为 “企” 。线上信用微课，给企业最专业的帮助。</div>
             -->
          <!--<div class="banner_text2">汇信科技，全心为 “企” 。线上信用微课，给企业最专业的帮助。
              </div>-->
          <!-- <div class="banner_btn" @click="hangleRepair">去培训
            </div>-->
          <!--</div>
          </div>-->
        </div>

      </div>
      <!-- 内容区 -->
      <!-- <kclb :qyShzt="qyShzt" :wsqy="wsqy" :qyLength="qyLength" :qyZfzt="qyZfzt" :qyId="qyId" @hangleLength="hangleLength"
         ref="flag"></kclb> -->
      <!-- //信用服务报告 -->
      <!-- <fwbg></fwbg> -->
      <!-- <smrz ref="smrz"></smrz> -->
      <!-- 内容区 -->
      <div class="content">
        <router-view :sfQyfr="sfQyfr" ></router-view>
      </div>
      <!-- <div class="con1" v-if="switchActive==0">
        <div class="index_index indexConter" :class="companyList && companyList.length > 0 ? 'padd' : ''">
          <kclb></kclb>
        </div>
      </div> -->
      <!-- 课程分类 -->
      <!-- <div class="con2" v-if="switchActive==1">
          <pxkc @hangleEmit="hangleEmit" @hangleLogin="hangleLogin" :activeLxid="activeLxid"></pxkc>
      </div> -->
    </div>
    <!-- <div v-else>
      <indexHeader ref="indexHeader" fromPage="index" :switchActive="switchActive" @hangleActive="hangleActive" :class="isFixed == true ? 'isfixed' : ''"></indexHeader>
      <pxkc @hangleEmit="hangleEmit" @hangleLogin="hangleLogin" :activeLxid="activeLxid"></pxkc>
    </div> -->
    <!-- 底部 -->
    <indexFooter></indexFooter>
  </div>
</template>
<script>
  import {
    cookie
  }

  from "@/common/js/cookies.js";
  import smrz from "@/components/common/shrz";
  import xjxf from "@/components/common/xyxf";
  import swiper from "@/components/index/index_swiper";
  // import pxkc from "@/components/index/courseIndex"; //课程分类
  // import pxkc from "@/components/index/index_pxkc"; //课程分类
  // import kclb from "@/components/index/indexContent";
  // import kclb from "@/components/index/index_kclb";//原来的首页内容区
  // import fwbg from "@/components/index/index_fwbg";//原来的首页内容区 信用服务报告
  import indexHeader from "@/components/index/index_header";
  import indexFooter from "@/components/index/index_footer";

  export default {
    components: {
      indexHeader,
      indexFooter,
      smrz,
      xjxf,
      swiper,
      // pxkc,
      // kclb,
      // fwbg,
    },
    name: "index_index",
    data() {
      return {
        bannerList:[],
        tel: null,
        sqtoken: null,
        //授权委托书下载状态
        sfsq: 0,
        //是否授权能参与培训
        company: null,
        qyPxzt: null,
        //1认证，2培训，3.考试，4考核报告
        sfQyfr: null,
        //用户是否企业法人  0 否 1，是
        qyShzt: null,
        // 审核状态  0 未审核 1 审核通过，-1审核不通过,2复审通过
        qyZfzt: null,
        //企业支付状态  0 未支付  1 已支付
        qyId: null,
        //企业ID
        pxrId: null,
        //培训人ID
        qyIa01: 0,
        //是否有报告
        qyFwnr: null,
        //培训服务选项 0 培训 1信用报告 2培训+信用报告
        companyList: [],
        tokenIndex: 0,
        isFixed: false,
        //用来判断是否吸顶
        zkMore: false,
        //是否展开更多
        yjshrq: null,
        //预计审核结果的日期
        fileUrl: null,
        //授权他人情况下出现下载模板地址
        yhsm1: null,
        //是否实名
        qyMc: null,
        //企业名称
        switchActive: 0,
        //0 首页  1培训课堂
        activeOne: null,
        //判断是否点击更多
        dialogVisible: false,
        //弹框显示
        qyLength: null,
        //企业的长度
        qyValue: null,
        //当前企业的id
        lxId: null,
        //类型id
        obj: {}

        ,
        //传给头部的数据 实名状态和培训人姓名
        activeLxid: null,
        //点击更多  给出当前的lxid
        lctitle: {
          kc: 0,
          xs: 0,
          state: "请先完成前面两个流程",
          stata: 0,
        }

        ,
        wsqy: null,
        //是否外省企业1是其他不是
      }

      ;
    }

    ,
    computed: {
      token() {
        return cookie.get("xyxf_token_qt");
      },
      yhsm() {
        return this.$store.state.yhsm;
      },
    },
    watch:{
      $route(newVal,oldVal){
        // console.log(newVal)
        // 回到顶部
          document.body.scrollTop = document.documentElement.scrollTop = 0;
        if(this.$route.path=='/'||this.$route.path=='/courseIndex'){
          this.getBannerList()
        }
      }
    },
    created() {
      this.getBannerList();
      let active = this.$route.query.active;
      if (active) {
        this.switchActive = active;
      }

      if (this.$route.query.ST && this.$route.query.ST == 1) {
        this.$router.push("/yzf");
      }
    },
    mounted() {
      let _self = this;
      // document.getElementsByClassName("header")[0].style.background = "none";

      if (this.token) {
        _self.getUserQy(function() {
            if (_self.qyPxzt >= 2) {
              _self.pxrCheck();
            } else {
              cookie.delete("zdyi_time_out");
            }
          }

        );
      }

      //当流程未进行到第二步之后时清空一下,防止用户直接从第一步走到第二步之后自动跳
      this.$nextTick(() => {
          window.addEventListener("scroll", this.handleScroll, true);
        }

      );
    }

    ,
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    }

    ,
    methods: {
      //获取banner轮播图列表
      getBannerList(){
        let state;
        if(this.$route.path=='/'){
          state=1;
        }else if(this.$route.path=='/courseIndex' || this.$route.path=='/schedule'){
          state=2;
        }
        this.$http.post(SOWINURL+'banner/getBanner',{
          bannerType:state
        }).then(res=>{
          if(res.data.result==1){
            this.bannerList=res.data.data;
          }
        }).catch(err=>{

        })
      },
      // 在培训课堂未登入的状态
      hangleLogin(id) {
        this.switchActive = id;
      }

      ,
      // 点击去培训来判断
      hangleRepair() {
        this.$refs.flag.dialogVisible = true;
        this.$refs.flag.flag = 1;
        this.$refs.flag.clickTarget = 'btn';
      }

      ,
      // 点击视频做判断
      hangleEmit(idx) {}

      ,
      // 判断是否有企业
      hangleLength(idx, type) {
        this.lxId = type;

        if (idx) {
          this.dialogVisible = true;
        }
      }

      ,
      // 绑定企业
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
              this.getEnterprise();
              // this.$refs.btnClick.hangleVideo(_self.btnKcid);
            } else {
              console.log("error submit!!");
              return false;
            }
          }

        );
      }

      ,
      // 获取高度
      handleScroll() {
        // 获取滚轮的高度
        let scrolled = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        // let scrollHeight = document.documentElement.scrollTop; // 滚动条的滚动行程
        let wHeight = document.getElementById('app');
        let vH=window.innerHeight;
        // console.log(vH,'内容高度')
        // if(window.getComputedStyle){
          // let contentHeight = window.getComputedStyle(app).height // 内容高度
        // }else{
          let contentHeight = wHeight.offsetHeight // 内容高度
        // }

        // 判断大于60就吸顶
        if (scrolled > 80 && (contentHeight/vH)>1.2) {
          this.isFixed = true;
        } else {
          this.isFixed = false;
        }
      }

      ,
      // 头部切换传的值
      hangleActive(idx, activeLxid) {
        this.switchActive = idx;
        this.activeLxid = activeLxid;
      }

      ,
      //banner报告查询
      rouBg() {
        if (!this.token) {
          this.$refs.indexHeader.getWx();
          cookie.set("zdyi_time_out", 2, 1); //加上cookie
        } else if (this.qyPxzt < 2) {
          this.$refs.bann.xjxf();
        }
      }

      ,
      //banner新建信用培训
      rouSe() {
        if (!this.token) {
          this.$refs.indexHeader.getWx();
          cookie.set("zdyi_time_out", 1, 1); //加上cookie
        } else if (this.qyPxzt < 2) {
          this.$refs.bann.xjxf();
        }
      }

      ,
      //点击下拉框选中企业
      getQy(da) {
        this.setUserQy();
      }

      ,
      //点击banner
      bannerClick() {
        if (this.token) {
          this.$refs.bann.xjxf();
        } else {
          this.$refs.indexHeader.getWx();
        }
      }

      ,
      //页面进入之前判断是否存在cookie和从哪个页面转过来的从而进入培训当中的页面
      // PathUrl(){
      // 	//获取用户企业列表
      // 	let coo = cookie.get("xyxf_token_qt");
      // 	let zdyi = cookie.get("zdyi_time_out");			//自定义一个cookie
      // 	let _self = this;
      // 	let zt = _self.qyPxzt;
      // 	let qyId = _self.qyId;
      // 	let pxrId = _self.pxrId;
      // 	if(coo  && zdyi){
      // 		//授权或是本人进入
      // 		if(zdyi == 0){
      // 			if(_self.sfsq == 1){
      // 				if(zt == 4 && _self.qyIa01 == 3){
      // 					window.open('/report?qyId=' + qyId + '&pxrId=' + pxrId )
      // 				}else if(zt == 3){
      // 					_self.$router.push('/exam')
      // 				}else if(zt == 2){
      // 					_self.$router.push('/');
      // 				}
      // 				cookie.delete("zdyi_time_out");
      // 			}
      // 		}else if(zdyi == 1){
      // 			cookie.delete("zdyi_time_out");
      // 			_self.$router.push('/qyrz');

      // 		}else if(zdyi == 2 && zt >= 2){	//点击查看报告有就跳转,没有就回到第一步,按确定进行,大于等于第二步才执行
      // 			if(_self.qyPxzt >= 4 && _self.qyIa01 == 3 && _self.qyFwnr == 2 && _self.qyShzt != 2  || (_self.qyFwnr == 1 && _self.yhsm == 1 && _self.qyShzt == 1
      //             && _self.qyIa01 == 3)){
      // 				let alertD = `
      // 					<div class='mk_title'>
      // 						<i class='el-icon-success'></i>
      // 						授权登录成功
      // 					</div>
      // 					<div class='mk_center'>
      // 						您可至【信用报告】模块查阅报告详情
      // 					</div>
      // 				`;
      // 				_self.$alert(alertD, '', {
      // 					  confirmButtonText: '确定',
      // 					  showClose: false,
      // 					  dangerouslyUseHTMLString: true,
      // 					  callback: action => {
      // 						window.open('/report?qyId=' + qyId + '&pxrId=' + pxrId )
      // 					  }
      // 				});
      // 			}else{
      // 				let alertData = _self.qyMc;
      // 				if(!alertData){
      // 					return
      // 				}
      // 				let alertD = `
      // 					<div class='mk_title'>
      // 						<i class='el-icon-success'></i>
      // 						授权登录成功
      // 					</div>
      // 					<div class='mk_center'>
      // 						【${alertData}】信用培训还未完结
      // 					</div>
      // 				`;
      // 				_self.$alert(alertD, '', {
      // 					  confirmButtonText: '确定',
      // 					  showClose: false,
      // 					  dangerouslyUseHTMLString: true,
      // 					  callback: action => {
      // 						cookie.set ('zdyi_time_out', 0, 1);		//没有报告时再跳到第一步
      // 						_self.PathUrl();
      // 					  }
      // 				});
      // 			}
      // 			cookie.delete("zdyi_time_out");
      // 		}

      // 	}

      // },
      downs(type) {
        let _self = this;
        let ajax = _self.$http.create();

        ajax({

            method: "post",
            url: SOWINURL + "report/getQyfj",
            data: {
              qyId: _self.qyId,
              fjType: type,
            }

            ,
            headers: {
              token: cookie.get("xyxf_token_qt"),
            }

            ,
          }

        ).then(function(json) {
            // console.log(json.data.data);
            _self.download(json.data.data);
          }

        ).catch(function(error) {
            console.log(error);
          }

        );
      }

      ,
      download(data) {
        if (!data) {
          return;
        }

        let url = data;
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "");
        link.setAttribute("target", "_blank");

        document.body.appendChild(link);
        link.click();
      }

      ,
      xxrzClick() {
        window.scroll(0, 0);

        if (this.qyShzt == 0) {
          // this.$router.push("/ddsh?tel=" + this.tel);
          this.$router.push("/ddsh");
        } else if (this.qyShzt == -1) {
          this.$router.push("/qyrz?edit=1&qyId=" + this.qyId);
        } else if ((this.qyShzt == 1 && this.qyZfzt == 0) || (this.qyShzt == 2 && this.qyZfzt == 0)) {
          this.$router.push({

              path: "/dzf",
              query: {
                id: this.qyId,
              }

              ,
            }

          );
        } else if ((this.qyShzt == 1 && this.qyZfzt == 1) || (this.qyShzt == 2 && this.qyZfzt == 1)) {
          this.$router.push("/yzf");
        }
      }

      ,
      pxrCheck: function(callback) {
          let _self = this;
          let ajax = _self.$http.create();

          const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
              target: document.querySelector("#app"),
            }

          );

          ajax({

              method: "post",
              url: SOWINURL + "index/pxrCheck",
              data: {}

              ,
              headers: {
                token: cookie.get("xyxf_token_qt"),
              }

              ,
            }

          ).then(function(json) {
              loading.close();

              // console.log(json.data);
              if (json.data.result == 1) {
                _self.sfsq = json.data.data.sfsq;
                _self.fileUrl = json.data.data.fileUrl;
                //页面进入之前判断是否存在cookie和从哪个页面转过来的从而进入培训当中的页面
                // _self.PathUrl()
                // 获取学时
                // _self.getData1();
                // 获取已学课程
                // _self.getDataList1();
                // 获取考试状态
                // _self.getData2();
                callback && callback();
              } else {
                // _self.$message({
                //   showClose: true,
                //   message: json.data.errorcode,
                //   type: "error"
                // });
              }

            }

          ).catch(function(error) {
              console.log(error);
              loading.close();
            }

          );
        }

        ,
      setUserQy() {
        //设置当前操作企业
        let _self = this;
        let ajax = _self.$http.create();

        const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            target: document.querySelector("#app"),
          }

        );

        ajax({

            method: "post",
            url: SOWINURL + "index/setUserQy",
            data: {
              qyId: _self.company,
            }

            ,
            headers: {
              token: cookie.get("xyxf_token_qt"),
            }

            ,
          }

        ).then(function(json) {
            loading.close();

            // console.log(json.data);
            if (json.data.result == 1) {
              _self.qyPxzt = json.data.data.qyPxzt;
              _self.sfQyfr = json.data.data.sfQyfr;
              _self.qyShzt = json.data.data.qyShzt;
              _self.qyZfzt = json.data.data.qyZfzt;
              _self.tel = json.data.data.pxrSjh;
              _self.qyId = json.data.data.qyId;
              _self.pxrId = json.data.data.pxrId;
              _self.qyIa01 = json.data.data.curQy.qyIa01;
              _self.qyFwnr = json.data.data.curQy.qyFwnr;
              if (_self.qyPxzt >= 2) _self.pxrCheck();
            } else {
              _self.$message({
                  showClose: true,
                  message: json.data.errorcode,
                  type: "error",
                }

              );
            }

          }

        ).catch(function(error) {
            loading.close();
            console.log(error);
          }

        );
      }

      ,
      getUserQy: function(callback) {
          //获取用户企业列表
          let _self = this;
          let ajax = _self.$http.create();

          const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)",
              target: document.querySelector("#app"),
            }

          );

          ajax({

              method: "get",
              url: SOWINURL + "index/getUserQy",
              headers: {
                token: cookie.get("xyxf_token_qt"),
              }

              ,
            }

          ).then(function(json) {
              loading.close();

              // console.log(json.data);
              if (json.data.result == 1) {
                _self.tokenIndex = 1;
                _self.yhsm1 = json.data.data.yhsm;
                _self.companyList = json.data.data.qyList;

                if (_self.companyList && _self.companyList.length > 0) {
                  _self.qyLength = _self.companyList.length || 0; //获取数组的长度
                }
                // if(json.data.data.pxrXm){
                //   _self.obj.sm = json.data.data.yhsm;
                //   _self.obj.pxrXm = json.data.data.pxrXm;
                // }
                // sfQyfr 是否是企业法人 是 法人 否 经办人
                _self.company = json.data.data.qyId;
                _self.qyPxzt = json.data.data.qyPxzt;
                _self.sfQyfr = json.data.data.sfQyfr;
                _self.qyShzt = json.data.data.qyShzt;
                _self.qyZfzt = json.data.data.qyZfzt;
                _self.yjshrq = json.data.data.shts;
                _self.tel = json.data.data.pxrSjh;
                _self.qyId = json.data.data.qyId;
                _self.pxrId = json.data.data.pxrId;
                _self.$store.state.tel = json.data.data.pxrSjh;
                _self.$store.state.yhsm = json.data.data.yhsm;
                _self.$store.state.user = json.data.data;

                // console.log(json.data.data.curQy)
                if (json.data.data.curQy) {
                  _self.qyValue = json.data.data.curQy.qyId;
                  _self.qyFwnr = json.data.data.curQy.qyFwnr;
                  _self.sqtoken = json.data.data.curQy.sqtoken;
                  _self.qyIa01 = json.data.data.curQy.qyIa01;
                  _self.qyMc = json.data.data.curQy.qyMc;
                  _self.wsqy = json.data.data.curQy.wsqy; //是否外省企业
                  _self.qyShzt = json.data.data.qyShzt; //企业审核状态

                }

                callback && callback();
              } else {
                // console.log(2);

                _self.$message({
                    showClose: true,
                    message: json.data.errorcode,
                    type: "error",
                  }

                );

                if (json.data.result == 2) {
                  setTimeout(() => {
                      //登录失效删除token
                      cookie.delete("xyxf_token_qt");
                      window.location.href = SOWINURL + "index/login";
                    }

                    , 2000);
                }
              }

            }

          ).catch(function(error) {
              console.log(error);
              loading.close();
            }

          );
        }

        ,
      goInClick(url) {
        if (this.$store.state.yhsm == 1) {
          window.open("/" + url);
        } else {
          this.$refs["smrz"].drawer = false;
        }
      }

      ,
      //获取学时
      // getData1: function () {
      //   let _self = this;
      //   let ajax = _self.$http.create();
      //   let data = {};
      //   ajax({
      //     method: 'post',
      //     url: SOWINURL + 'XxKh/getEnterpriseCenter',
      //     data: data,
      // 	headers:{
      // 		'token': cookie.get("xyxf_token_qt")
      // 	}
      //   }).then(function (json) {
      //     if (json.data.result == 1) {
      //       _self.lctitle.xs = json.data.data.xxglYxxs;
      //     }

      //   }).catch(function (error) {
      //     console.log(error);
      //   });
      // },
      //课程个数
      // getDataList1: function() {
      //      let _self = this;
      //      let ajax = _self.$http.create();
      //      let data = {};
      //      ajax({
      //        method: "post",
      //        url: SOWINURL + "XxKh/getLearningRecords",
      //        data: data,
      // 		headers:{
      // 			'token': cookie.get("xyxf_token_qt")
      // 		}
      //      })
      //        .then(function(json) {
      //          if (json.data.result == 1) {
      //           _self.lctitle.kc = json.data.data.length;
      //          }
      //        })
      //        .catch(function(error) {
      //          console.log(error);
      //        });
      //    },
      //获取考试状态
      // getData2: function () {
      //   let _self = this;
      //   let ajax = _self.$http.create();
      //   let data = {};
      //   ajax({
      //     method: 'post',
      //     url: SOWINURL + 'XxKh/verificationQualification',
      //     data: data,
      // 	headers:{
      // 		'token': cookie.get("xyxf_token_qt")
      // 	}
      //   }).then(function (json) {
      // 	  let state = json.data.result;
      // 	  _self.lctitle.stata = json.data.result;
      // 	  if(state == 1){
      // 		  _self.lctitle.state = '您已完成规定学时，祝您考试顺利';
      // 	  }else if(state == 2){
      // 		  _self.lctitle.state = '请您完成3学时再来参加考试';
      // 	  }else if(state == 3){
      // 		  _self.lctitle.state = '很抱歉，成绩不合格，请重新补考';
      // 	  }else if(state == 4){
      // 		  _self.lctitle.state = '考试时间为60分钟，祝您考试顺利';
      // 	  }else if(state == 5){
      // 		  _self.lctitle.state = '恭喜您，已通过考试！';
      // 	  }else{
      // 		  _self.lctitle.state = '请先完成前面两个流程';
      // 	  }

      //   }).catch(function (error) {
      //     console.log(error);
      //   });
      // },
    },

  };
</script>
<style scoped lang="less">
  .header1 {
    width: 100%;
    // background-color: inherit;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
  }

  .header2 {
    width: 100%;
    background-color: #FFFFFF;
    -webkit-box-shadow: 2px 2px 15px #dedede;
    box-shadow: 2px 2px 15px #dedede;
    z-index: 999;
    margin-bottom: 20px;

  }

  .bannerBg {
    // background: url(/static/images/new/25d@2x.png);
    background-size: 100% 100%;
    position: relative;

  }

  .isfixed {
    position: fixed;
    top: 0;
    z-index: 999;
    // background-color: red;
    // background-color: #1D6AFD;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 15px rgb(222, 222, 222);
  }

  .ks_box {
    // width: 1920px;
    height: 400px;
    // position: absolute;
    // left: 50%;
    // top: 0;
    // margin-left:-960px;
    // z-index: 10;
    // width: 1210px;
    width: 1180px;
    margin: 0 auto;
  }

  .ks_btn {
    width: 530px;
    // margin: 0 auto;
    margin-top: -120px;
  }

  .ks_btn>button {
    outline: none;
    border: none;
    background-color: #ffffff;
    width: 215px;
    height: 60px;
    border-radius: 30px;
    font-size: 14px;
    text-align: left;
    padding-left: 65px;
    font-size: 20px;
    font-weight: 700;
    // background: linear-gradient(to right, rgba(0,118,255,0.8), rgba(0,118,255,0.2));
    // background: -webkit-gradient(linear, left top, right top, from(rgba(0,118,255,0.8)), to(rgba(0,118,255,0.2)));
    // opacity: 0.5;
    color: #1a35a8;
    position: relative;
    cursor: pointer;
  }

  .ks_btn>button i {
    width: 29px;
    height: 29px;
    position: absolute;
    left: 25px;
    top: 16px;
    background: url(/static/images/ico2.png) no-repeat center center;
  }

  .ks_btn>.ico1 {
    margin-right: 40px;
    width: 260px;
  }

  .ks_btn>.ico1 i {
    background: url(/static/images/ico1.png) no-repeat center center;
  }

  .index_nav a {
    cursor: pointer;
  }

  .txt_a {
    display: block;
    height: 30px;
    line-height: 30px;
    width: 80%;
    margin: 0 auto;
    font-size: 16px;
    text-align: center;
    color: #02baef;
    text-decoration: underline;
  }

  .txt_top {
    padding-top: 67px;
  }

  .index_index {
    position: relative;
    // padding-top: 660px;
    width: 100%;
    // background: #fff;
  }

  .bannerImg {
    height: 418px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .indexConter {
    background-color: #FFFFFF;
  }

  .banner_img {
    height: 492px;
    // background: url(/static/images/banner2.png) no-repeat center center;
    background-size: 100% 100%;
    display: flex;
    // flex-direction: column;
    align-items: center;

    .banner_warp {
      // width: 1210px;
      width: 1180px;
      margin: 0 auto;

      .banner_title {
        font-size: 80px;
        // font-family: 'chuangheicu';
        color: rgba(254, 254, 254, 1);
        line-height: 48px;
      }

      .banner_text {
        // max-width: 583px;
        margin-top: 38px;
        font-size: 20px;
        // font-family: 'chuangheicu';
        line-height: 30px;
        color: rgba(254, 254, 254, 1);
      }

      // .banner_text2 {
      //   // max-width: 583px;
      //   // margin-top: 38px;
      //   font-size: 20px;
      //   font-family: 'chuangheicu';
      //   line-height: 30px;
      //   color: rgba(254, 254, 254, 1);
      // }
      .banner_btn {
        cursor: pointer;
        margin-top: 107px;
        width: 100px;
        height: 40px;
        padding: 5px 0 10px;
        background: rgba(252, 112, 89, 1);
        border-radius: 20px;
        color: #fff;
        font-size: 20px;
        text-align: center;
        font-family: 'chuangheicu';
        box-sizing: border-box;
      }
    }
  }

  .padd {
    padding-top: 0;
  }

  .xjxf_wrap {
    margin-top: 20px;
    float: right;
  }

  .banner {
    width: 1920px;
    height: 400px;
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: -960px;
  }

  .ckgdDnr {
    width: 100%;
    max-height: 220px;
    clear: both;
    overflow: hidden;
  }

  .zkgd-more {
    width: 100%;
    height: 30px;
    margin-top: 20px;
    color: #0076ff;
    text-align: center;
    cursor: pointer;
  }

  .desc {
    width: 1150px;
    padding: 20px 30px;
    background: #edeeef;
    margin: 90px auto 90px;
    text-align: left;

    .tip {
      color: #0076ff;
      font-size: 18px;
      margin-left: -10px;
      height: 56px;
      line-height: 56px;
      font-weight: bold;
    }

    .desc_con1 {
      margin-bottom: 40px;
    }

    .desc_con1 h3 {
      height: 45px;
      line-height: 45px;
      font-size: 20px;
      color: #06103b;
      margin-bottom: 7px;
    }

    .desc_con2 {
      margin-bottom: 20px;
    }

    .desc_con2 h4 {
      height: 30px;
      line-height: 30px;
      font-size: 16px;
      color: #06103b;
    }

    .desc_con3 p {
      font-size: 14px;
      color: #06103b;
      line-height: 28px;
    }

    .desc_con3 span {
      font-size: 14px;
      color: #f6472a;
    }

    .desc_con4 p {
      font-size: 14px;
      color: #06103b;
      line-height: 28px;
      padding-left: 40px;
    }
  }

  .index_nav {
    font-size: 0;
    margin: 20px auto 0;
    overflow: hidden;

    .index_nav_li {
      padding-top: 46px;
      width: 287px;
      height: 354px;
      overflow: hidden;
      background: #fff;
      display: inline-block;
      margin-right: 20px;

      img {
        width: 170px;
        display: block;
        margin: 0 auto;
      }

      p {
        height: 52px;
        line-height: 52px;
        text-align: center;
        font-size: 20px;
        color: #06103b;
      }

      .txt {
        height: 26px;
        line-height: 26px;
        text-align: center;
        font-size: 16px;
        color: #9199aa;
        margin-bottom: 30px;
      }

      .go_in {
        display: block;
        width: 118px;
        height: 34px;
        line-height: 34px;
        margin: 0 auto;
        border: 1px solid #0076ff;
        text-align: center;
        font-size: 18px;
        color: #0076ff;
        border-radius: 16px;
        cursor: pointer;
      }

      .go_in.end {
        color: #b9bdc8;
        border: 1px solid #b9bdc8;
      }
    }

    .index_nav_li:hover .activeImg {
      animation: moveTop 0.5s;
      -moz-animation: moveTop 0.5s;
      /* Firefox 4 */
      -webkit-animation: moveTop 0.5s;
      /* Safari 和 Chrome */
      -o-animation: moveTop 0.5s;
      /* Opera */
      animation-fill-mode: forwards;
    }

    .index_nav_li:last-child {
      margin-right: 0;
    }
  }

  .process {
    background: #f5f6f6;
  }

  .el-radio.is-bordered+.el-radio.is-bordered {
    margin-left: 0;
  }

  .gs_total {
    width: 96.5%;
    background: #fff;
    padding: 20px;
  }

  .qy-total-mc {
    color: #f63035;
    font-size: 16px;
  }

  .qymc-list-item {
    width: 96%;
    padding: 15px 20px;
    font-size: 16px;
    color: #06103b;
    // background: #0076ff;
    border: 1px solid #e8e8e8;
    margin-top: 20px;
    border-radius: 5px;
    float: left;
    cursor: pointer;
  }

  .qyipt {
    width: 100%;
    padding-top: 20px;
  }

  .qymc-list-item:nth-child(even) {
    // margin-left: 20px;
  }

  .qymc-list-item:nth-child(odd) {
    // margin-right: 20px;
  }

  .activeMc {
    background: #0076ff;
    color: #fff;
  }

  .curren-qyzt {
    color: #c0c2cd;
    font-size: 16px;
    float: right;
  }

  .navBarWrap {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .prise_center {
    display: flex;
    margin: 50px 30px;
    color: #0076ff;
  }

  .prise_left {
    flex: 1;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/index_index.vue